/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Top_Partners_SubtitleInputs */



/**
* | output |
* | --- |
* | "Highest current-period managed AI cost." |
*
* @param {Partner_Dashboard_Top_Partners_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_top_partners_subtitle = /** @type {((inputs?: Partner_Dashboard_Top_Partners_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Top_Partners_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Höchste verwaltete KI-Kosten im aktuellen Zeitraum.")
	return /** @type {LocalizedString} */ ("Highest current-period managed AI cost.")
});